import axios from 'modules/api-client/request';

import type { IReservation } from './types';
import type { IListMeta } from 'models/types';
import type { IMetaResponse } from '../types';

export const getUserReservationsRequest = (params: IListMeta) => {
  return axios.get<void, IMetaResponse<IReservation[], IListMeta>>('/user/reservations', { params });
};
